// extracted by mini-css-extract-plugin
module.exports = {"info":"tweet-info_info__CuSKZ","infoLink":"tweet-info_infoLink__DraCb","infoIcon":"tweet-info_infoIcon__qpLpG"};